function getOrderGroupId(order) {
    return order.address + "~" + order.status + "~" + order.placeOfDeparture + "~" + order.source + "~" + !!order.redirectedFromBid;
}

function groupOrders(orders) {
    const groups = {};

    for (let order of orders) {
        const orderGroupId = getOrderGroupId(order);
        if (orderGroupId in groups) groups[orderGroupId].push(order); else groups[orderGroupId] = [order];
    }

    return groups;
}

export function evaluateOrderGroups(orders, merukazotMin, ignoredOrderIdsForGrouping) {
    const groupsByAddress = groupOrders(orders);

    const newOrderGroups = [];
    const newOrderGroupsIndex = {};

    for (let order of orders) {
        const orderGroupId = getOrderGroupId(order);
        const groupLength = groupsByAddress[orderGroupId].length;

        if (groupLength >= merukazotMin && !ignoredOrderIdsForGrouping.includes(order.id)) {
            if (orderGroupId in newOrderGroupsIndex) {
                const orderGroupArrIndex = newOrderGroupsIndex[orderGroupId];
                newOrderGroups[orderGroupArrIndex].push(order);
            } else {
                newOrderGroupsIndex[orderGroupId] = newOrderGroups.length;
                newOrderGroups.push([order])
            }
        } else {
            newOrderGroups.push([order])
        }
    }

    return newOrderGroups;
}